import { render, staticRenderFns } from "./tka.vue?vue&type=template&id=f98d857a"
import script from "./tka.vue?vue&type=script&lang=js"
export * from "./tka.vue?vue&type=script&lang=js"
import style0 from "./tka.vue?vue&type=style&index=0&id=f98d857a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports